import Swiper from 'swiper';
import { EffectFade, Navigation, Thumbs } from 'swiper/modules';

/**
 * Initializes the timeline swiper and its pagination thumbs.
 */
const timeline = function () {
    const carousel = document.querySelector('.timeline__timeline.swiper');
    const pagination = document.querySelector('.timeline__pagination.swiper');

    if (!carousel || !pagination) {
        return;
    }

    const paginationSwiper = new Swiper(pagination, {
        modules: [Navigation, Thumbs],
        slidesPerView: 2.5,
        centeredSlides: false,
        watchSlidesProgress: true,
        slideToClickedSlide: true,

        breakpoints: {
            640: {
                slidesPerView: 6,
                centeredSlides: false,
            },
            940: {
                slidesPerView: 10,
            },
        },
    });

    const carouselSwiper = new Swiper(carousel, {
        modules: [EffectFade, Navigation, Thumbs],
        slidesPerView: 1,
        effect: 'fade',
        fadeEffect: {
            crossFade: true,
        },
        navigation: {
            nextEl: '.timeline__pagination-controls .swiper-button-next',
            prevEl: '.timeline__pagination-controls .swiper-button-prev',
            disabledClass: 'swiper-button-disabled',
        },
        thumbs: {
            swiper: paginationSwiper,
        },
        on: {
            slideChange: () => {
                if (paginationSwiper.activeIndex !== carouselSwiper.activeIndex) {
                    paginationSwiper.slideTo(carouselSwiper.activeIndex);
                }
            },
        },
    });
};

export default timeline;
